<div class="data-terminal-sign-in-connect">
    <mat-icon svgIcon="hdmui:swap"></mat-icon>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    <p class="data-terminal-sign-in-connect__label">{{ 'DC.APP.SIGN_IN_CONNECT' | translate }}</p>
</div>
